import { useCallback, useEffect, useRef, useState } from 'react';
import { useStripe } from '@stripe/react-stripe-js';

export default function useStripeCard(cardElement, callback) {
  const [loading, setLoading] = useState(false);
  const savedCallback = useRef();
  const stripe = useStripe();

  useEffect(() => {
    savedCallback.current = callback;
  });

  const createPaymentMethod = useCallback(async () => {
    setLoading(true);

    const { error, paymentMethod } = await stripe.createPaymentMethod({
      type: 'card',
      card: cardElement,
    });

    setLoading(false);

    if (error) {
      console.error('Unable to use this payment method: ', error);
      savedCallback.current(null, error);
      return;
    }

    savedCallback.current(
      {
        last4: paymentMethod.card.last4,
        id: paymentMethod.id,
      },
      null,
    );
  }, [cardElement, stripe]);

  return [createPaymentMethod, loading];
}
